import LeftPointerArrowIcon from './LeftPointerArrowIcon'

export default LeftPointerArrowIcon
